import {ActivatedRouteSnapshot} from '@angular/router';
import {inject} from '@angular/core';
import {FitApiService} from '../api/fit-api/fit-api.service';
import {map} from 'rxjs/operators';
import {forkJoin} from 'rxjs';
import {resolveGarfieldFiledFundNodes} from './garfield-filed-fund-nodes.resolver';

/**
 * Resolve and return the debt category, debt type, and debt item lookups
 *
 * TEMPORARY - Get rid of this once we convert to the new reporting pattern and use of the new Reference object
 *
 * @param route
 * @param state
 */
export const garfieldDebtReferenceLookupsResolver= (route: ActivatedRouteSnapshot, state: any) => {
	return resolveDebtReferenceLookups(route);
};

export const resolveDebtReferenceLookups = (route: ActivatedRouteSnapshot)=> {
	const fitApiService = inject(FitApiService);

	return forkJoin([
		fitApiService.getBonanzaSchedule9Categories(),
		fitApiService.getBonanzaSchedule9Types(),
		fitApiService.getBonanzaSchedule9Items()
	]).pipe(map(([categories, types, items]) => {
		return {categories: categories, types: types, items: items}
	}));
};


